import { StudentNotesPanel } from '../../features/notes/StudentNotesPanel';
import { formatClock, formatDuration } from '../../features/pilotMath/format';
import { pilotSummary } from '../../features/pilotMath/store';
import { usePilotState } from '../../features/pilotMath/usePilotState';
import { usePilotLearnerRecord } from '../../features/pilotMath/usePilotLearnerRecord';
import { flattenLearnerAttempts } from '../../features/pilotMath/learnerHistory';

export function AdminStudentsPage() {
  const [state] = usePilotState();
  const summary = pilotSummary(state);
  const learner = usePilotLearnerRecord();
  const allAttempts = flattenLearnerAttempts(learner);
  return (
    <div className="stack">
      <div><h1>Record Murid</h1><p className="muted">Pilot menampilkan satu murid demo. Production akan dibatasi berdasarkan cabang dan role.</p></div>
      <section className="card student-monitor-card">
        <div className="student-monitor-card__header">
          <div><div className="eyebrow">Demo record</div><h2>{state.student.displayName}</h2><p className="muted">Matematika · {state.learningDate}</p></div>
          <span className={`status-dot status-dot--${state.status}`}>{state.status === 'completed' ? 'Selesai' : state.status === 'in_progress' ? 'Sedang belajar' : 'Belum mulai'}</span>
        </div>
        <div className="grid grid--3">
          <div className="metric"><span>Selesai</span><strong>{summary.completed}/{summary.totalQuestions}</strong></div>
          <div className="metric"><span>First-attempt</span><strong>{summary.firstAttemptAccuracy}%</strong></div>
          <div className="metric"><span>Aktif</span><strong>{formatDuration(summary.totalActiveMs)}</strong></div>
        </div>
      </section>
      <section className="card">
        <h2>History terbaru</h2>
        <div className="history-list">
          {allAttempts.slice(0, 10).map((attempt) => (
            <article className="history-item" key={attempt.id}>
              <div><strong>{attempt.prompt}</strong><div className="muted">{attempt.skillLabel}</div></div>
              <div className="history-item__detail"><span>{attempt.firstAttemptCorrect ? '✓ first attempt' : `${attempt.firstResponse} → ${attempt.finalResponse}`}</span><span>{formatDuration(attempt.duration.activeDurationMs)}</span><span>{formatClock(attempt.completedAt)}</span></div>
            </article>
          ))}
          {allAttempts.length === 0 && <p className="muted">Belum ada history.</p>}
        </div>
      </section>
      <StudentNotesPanel studentId={state.student.id} viewerRole="branch_admin" authorName="Admin BelajarKu" allowCreate defaultNoteType="follow_up" subjectCode="MTH" />
    </div>
  );
}
